/* Product quote stays native to Shopify. Copy configuration, never overwrite the message. */
(function () {
  'use strict';
  function start() {
    var enquiry = document.querySelector('[data-product-enquiry]');
    if (!enquiry) return;
    var panel = enquiry.querySelector('[data-product-enquiry-panel]');
    var source = document.querySelector('form[data-build-handle]');
    var triggers = Array.from(document.querySelectorAll('[data-product-enquiry-open]'));
    var review = enquiry.querySelector('[data-enquiry-choices]');
    var estimate = enquiry.querySelector('[data-enquiry-estimate]');
    var storageKey = 'nhl:pdp-enquiry-submission:v1:' + enquiry.dataset.enquiryHandle;
    var inView = false;
    var budget = enquiry.querySelector('[data-product-budget]'), timing = enquiry.querySelector('[data-product-timing]');
    function qualification() {
      if (budget) {
        var option = budget.options[budget.selectedIndex], value = option && option.dataset.budgetQualification || '';
        enquiry.querySelector('[data-product-budget-result]').value = value;
        enquiry.querySelector('#product-budget-warning').hidden = value !== 'below_start';
      }
      var date = enquiry.querySelector('[data-product-date]');
      if (date && timing) { date.hidden = timing.value !== 'I have a target date'; date.querySelector('input').disabled = date.hidden; }
    }
    function restoreChoice(select, value) { if(select && Array.from(select.options).some(function(option){return option.value === value;})) select.value = value; }

    function snapshot() {
      var groups = {};
      if (source) source.querySelectorAll('[data-cfg-group]').forEach(function (group) {
        groups[group.dataset.cfgGroup] = Array.from(group.querySelectorAll('input:checked:not(:disabled)')).map(function (input) { return input.value; });
      });
      return { at: Date.now(), groups: groups, qualification: {budget:budget ? budget.value : '', timing:timing ? timing.value : ''} };
    }
    // Keep the chosen build on refresh/return as well as validation errors. Store no contact details or free text.
    if (source && panel.dataset.enquiryOutcome !== 'success') {
      try {
        var saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (saved && Date.now() >= saved.at && Date.now() - saved.at < 1800000 && saved.groups && typeof saved.groups === 'object') {
          source.querySelectorAll('[data-cfg-group]').forEach(function (group) {
            var values = saved.groups[group.dataset.cfgGroup];
            if (!Array.isArray(values)) return;
            var inputs = Array.from(group.querySelectorAll('input[type="radio"],input[type="checkbox"]'));
            var matches = inputs.filter(function (input) { return values.indexOf(input.value) !== -1; });
            if (inputs.some(function (input) { return input.type === 'radio'; }) && !matches.length) return;
            inputs.forEach(function (input) { input.checked = matches.indexOf(input) !== -1; });
          });
          source.dispatchEvent(new Event('change', { bubbles: true }));
          if(saved.qualification){restoreChoice(budget,saved.qualification.budget);restoreChoice(timing,saved.qualification.timing);}
        }
      } catch (_) { /* Native enquiry remains usable when functional storage is unavailable. */ }
    }
    function sync() {
      qualification();
      var lines = [];
      var mapped = enquiry.querySelector('[data-enquiry-mapped]'); if(mapped) mapped.replaceChildren();
      var labels = {'Case finish':'Case material','Bezel':'Bezel style','Dial colour':'Dial','Strap':'Strap','Complication':'Movement','Optional extras':'Optional extras'};
      review.replaceChildren();
      if (source) source.querySelectorAll('[data-cfg-group]').forEach(function (group) {
        var selected = Array.from(group.querySelectorAll('input:checked:not(:disabled)')).map(function (input) { return input.value; });
        if (!selected.length) return;
        lines.push(group.dataset.cfgGroup + ': ' + selected.join(', '));
        if (mapped && labels[group.dataset.cfgGroup]) { var hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = 'contact[' + labels[group.dataset.cfgGroup] + ']'; hidden.value = selected.join(', '); mapped.appendChild(hidden); }
        var row = document.createElement('div'), label = document.createElement('dt'), value = document.createElement('dd');
        label.textContent = group.dataset.stepTitle || group.dataset.cfgGroup;
        value.textContent = selected.join(', '); row.append(label, value); review.appendChild(row);
      });
      enquiry.querySelector('[data-enquiry-review]').hidden = !lines.length;
      var input = source && source.querySelector('[name="properties[Estimated total]"]');
      var total = input ? input.value : '';
      estimate.hidden = !total; estimate.textContent = total ? estimate.dataset.estimateLabel + ': ' + total : '';
      var field = enquiry.querySelector('[data-enquiry-total]'); if (field) field.value = total;
      field = enquiry.querySelector('[data-enquiry-configuration]'); if (field) field.value = lines.join('\n');
      field = enquiry.querySelector('[data-enquiry-provenance]');
      if (field && source) field.value = 'Current product selections, including unchanged initial defaults. Price, parts and final specification remain subject to Namir\'s itemised quote.';
    }
    function state() {
      triggers.forEach(function (trigger) { trigger.setAttribute('aria-expanded', String(panel.open)); });
      document.documentElement.classList.toggle('nhl-pdp-enquiry-active', panel.open && inView);
    }
    function open(focus) {
      sync(); panel.open = true; state();
      panel.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      if (focus) {
        var target = enquiry.querySelector('.pg-enquiry-success, .pg-enquiry-errors, input[name="contact[name]"]') || panel.querySelector('summary');
        target.focus({ preventScroll: true });
      }
    }
    triggers.forEach(function (trigger) { trigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (location.hash !== '#product-enquiry') history.replaceState(null, '', '#product-enquiry');
      open(true);
    }); });
    panel.addEventListener('toggle', function () { if (panel.open) sync(); state(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; state(); }).observe(panel);
    function remember() {
      try {
        if(panel.dataset.enquiryOutcome === 'success') sessionStorage.removeItem(storageKey);
        else sessionStorage.setItem(storageKey,JSON.stringify(snapshot()));
      } catch (_) {}
    }
    if (source) source.addEventListener('change', function () { queueMicrotask(function () { sync(); remember(); }); });
    enquiry.addEventListener('change', function () { qualification(); remember(); });
    window.addEventListener('pagehide',remember);
    if(panel.dataset.enquiryOutcome === 'success')remember();
    enquiry.addEventListener('submit', function () {
      sync();
      var message = enquiry.querySelector('[name="contact[body]"]');
      if(message && !message.value.trim())message.value = panel.dataset.enquiryEmptyMessage;
      try { sessionStorage.setItem(storageKey, JSON.stringify(snapshot())); } catch (_) {}
    });
    window.addEventListener('pageshow', function () { sync(); state(); });
    window.addEventListener('hashchange', function () { if (location.hash === '#product-enquiry') open(true); });
    sync(); state();
    if (panel.dataset.enquiryOutcome || location.hash === '#product-enquiry') open(true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
